import * as zod from 'zod';

import {
  ExternalControlControlledBy,
  ExternalControlStreamType,
} from './Arguments';

/**
 * Published into the routine-runner state so any client can read the live
 * session's modality straight from the runner (the single shared source of
 * truth) instead of re-deriving it from the robot's `latestRoutineID` + a
 * routine-row lookup, which races against ephemeral-routine reaping.
 */
export default zod.object({
  controlledBy: ExternalControlControlledBy,
  streamType: ExternalControlStreamType,
});
